import React, { useState, useEffect } from 'react';

export function Clock() {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setDate(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="card p-4 text-center md:text-right min-w-[180px]">
      <div className="text-sm sm:text-base font-semibold text-light-textSecondary dark:text-dark-textSecondary">
        {date.toLocaleDateString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
      </div>
      <div className="text-2xl sm:text-3xl font-bold text-primary-700 dark:text-primary-400 mt-1">
        {date.toLocaleTimeString('id-ID')}
      </div>
    </div>
  );
}
